export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13347.be39dc85.jpg";